import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { homeBase } from '../constants/routing';
const GuestGuard = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (isAuthenticated) {
        return _jsx(Navigate, { to: homeBase() });
    }
    return _jsx(_Fragment, { children: children });
};
GuestGuard.propTypes = {
    children: PropTypes.node,
};
export default GuestGuard;
//# sourceMappingURL=GuestGuard.js.map